var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('audio',{staticStyle:{"display":"none"},attrs:{"id":"audio"}},[_c('source',{attrs:{"src":"/img/dingdong.mp3","type":"audio/mpeg"}})])
}]

export { render, staticRenderFns }